import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl } from '../../boot/index.js';

export const getDepartment = createAsyncThunk("/department-list", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/hrm/app/v1/department-list`, data, { 
            headers: {
                "auth-token": token,
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching Vendor - ', error);
        throw error;
    }
})